import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import { OctTable } from "@oceantech/oceantech-ui";
import { AppContext } from "../../appContext/AppContext";
import { CODE, RESPONSE_MESSAGE } from "../../utils/Constant";
import { formatDateTime } from "../../utils/FormatUtils";
import { getDsDichVu } from "../services/ChamSocKhachHangService";

type Props = {
    benhNhanSelected: any;
    handleClose: () => void;
};

const ModalDsDichVu = ({
    benhNhanSelected,
    handleClose
}: Props) => {
    const { setIsLoading } = useContext(AppContext);
    const [data, setData] = useState<any>();

    const updatePageData = async () => {
        setIsLoading(true);
        try {
            let { data } = await getDsDichVu(benhNhanSelected?.visitId);
            if (data?.code === CODE.SUCCESS) {
                let listDV = data?.data?.filter((item: any) => !item?.isCanceled);
                setData(listDV || []);
            } else {
                toast.warning(RESPONSE_MESSAGE.ERROR);
            }
            setIsLoading(false);
        } catch (e) {
            toast.error(RESPONSE_MESSAGE.ERROR);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        updatePageData();
    }, []);

    const columns = [
        {
            name: "STT",
            field: "",
            headerStyle: {
                minWidth: "50px",
            },
            cellStyle: {
                textAlign: "center",
            },
            render: (row: any, index: number, stt: number) => <span>{stt}</span>,
        },
        {
            name: "Ngày y lệnh",
            field: "",
            headerStyle: {
                minWidth: "150px",
            },
            cellStyle: {
                textAlign: "center",
            },
            render: (rowData: any) =>
                rowData?.indicationTime
                    ? formatDateTime(rowData?.indicationTime)
                    : "",
        },
        {
            name: "Tên dịch vụ",
            field: "name",
            headerStyle: {
                minWidth: "200px",
            },
        },
        {
            name: "Người chỉ định",
            field: "requester",
            headerStyle: {
                minWidth: "150px",
            },
        },
        {
            name: "Phòng chỉ định",
            field: "requestDeptName",
            headerStyle: {
                minWidth: "200px",
            },
            cellStyle: {
                maxWidth: "200px",
            },
        },
    ];

    return (
        <>
            <Modal
                show
                centered
                size="xl"
                className="dialog-background"
                onHide={() => {
                    handleClose();
                }}
            >
                <Modal.Header closeButton className="modal-header">
                    <Modal.Title className="text-transform-none">Danh sách dịch vụ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="spaces min-h-400">
                        <OctTable
                            id="list-patients"
                            className="h-100 table-background-th"
                            data={data || []}
                            columns={columns}
                            //   searchObject={objectSearch}
                            //   setSearchObject={setObjectSearch}
                            notDelete={true}
                            notEdit={false}
                            noToolbar={true}
                            //   totalPages={configTable.totalPages}
                            //   totalElements={configTable.totalElements}
                            //   numberOfElements={configTable.numberOfElements}
                            //   handleDoubleClick={handleSelectBenhNhan}
                            //   setDataChecked={setSelectedBenhNhan}
                            //   selectionMode={TYPE.SINGLE_NO_RADIO_BUTTON}
                            fixedColumnsCount={-1}
                            isShowSelection={false}
                            clearToolbar={true}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-end">
                    <Button
                        className="btn-secondary spaces W-80"
                        onClick={handleClose}
                    >
                        Đóng
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalDsDichVu;
